import MISSION_TAB_DATA from "../data/MISSION_TAB_DATA";

const MissionTab = () => {
  const missionData = MISSION_TAB_DATA;

  return (
    <div className="space-y-4">
      {/* Mission Section */}
      <div
        className="flex flex-col justify-between items-center gap-2"
        style={{ minHeight: "fit-content" }}
      >
        <img
          src={missionData.mission.image.src}
          alt={missionData.mission.image.alt}
          className="flex-shrink-0 w-1/4 h-auto"
        />
        <div className="font-bold text-xl">Our Mission</div>
        <p className="text-center text-sm lg:text-base px-4">
          {missionData.mission.text}
        </p>
      </div>
      {/* Values Section */}
      <div
        className="flex flex-col justify-between items-center gap-2"
        style={{ minHeight: "fit-content" }}
      >
        <img
          src={missionData.values.image.src}
          alt={missionData.values.image.alt}
          className="flex-shrink-0 w-1/4 h-auto"
        />
        <div className="font-bold text-xl">Our Values</div>
        <div className="w-full px-4 space-y-2">
          {missionData.values.items.map((value, index) => (
            <div
              key={index}
              className="flex items-center justify-start gap-2 border-b-2 pb-2"
              style={{
                alignItems: "center",
                flexWrap: "nowrap",
              }}
            >
              <img
                src={value.icon}
                alt="Value Icon"
                className="flex-shrink-0 w-1/6 h-auto align-middle"
              />
              <div className="text-sm lg:text-base">
                <span className="font-bold">{value.title}: </span>
                <span>{value.text}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MissionTab;
